import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export interface InsightCardData {
  id: string;
  title: string;
  description?: string;
  value?: string;
  severity?: "info" | "warning" | "critical";
}

interface InsightsCardsProps {
  title?: string;
  subtitle?: string;
  items: InsightCardData[];
}

export function InsightsCards({ title = "Insights", subtitle, items }: InsightsCardsProps) {
  return (
    <section className="space-y-3">
      <div>
        <h2 className="text-lg font-semibold">{title}</h2>
        {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((item) => (
          <Card key={item.id} className="h-full">
            <CardHeader className="pb-3">
              <CardTitle className="text-base">{item.title}</CardTitle>
              {item.description && <CardDescription>{item.description}</CardDescription>}
            </CardHeader>
            {(item.value || item.severity) && (
              <CardContent className="pt-0">
                <div className="flex items-center justify-between">
                  <div className="text-sm font-mono">{item.value ?? ""}</div>
                  {item.severity && (
                    <div className="text-xs text-muted-foreground">{item.severity}</div>
                  )}
                </div>
              </CardContent>
            )}
          </Card>
        ))}
      </div>
    </section>
  );
}
